import React, { useState } from "react";
import EditSubjectIndex from "./EditSubject/index";
import useSubject from "../useSubject";
import EditImg from "../../../images/SideBar/Edit";
import Loader from "../../../components/Loader";
import CommonDataGrid from "../../../components/CommonDataGrid";
import Button from "../../../components/Botton";
import { Toaster } from "react-hot-toast";
import { GridColDef } from "@mui/x-data-grid";
import { TextField } from "@mui/material";
import DeleteImg from "../../../images/SideBar/Delete";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import { getSortByTimeButtonText } from "../../../util/getSortByTimeText";
import { hasPermission } from "../../../utils/permissions";
import { useAppSelector } from "../../../store/hooks";
import { selectUser } from "../../../store/slices/authSlice";
import { getDeleteConfirmationMessage } from "../../../utils/pagePermissions";

const Subject: React.FC = () => {
  const user = useAppSelector(selectUser);
  const canEdit = hasPermission(user, "subject", "update");
  const canAdd = hasPermission(user, "subject", "create");
  const canDelete = hasPermission(user, "subject", "delete");

  const columns: GridColDef[] = [
    {
      field: "languageName",
      headerName: "Education Language",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      filterable: true,
    },
    {
      field: "courseName",
      headerName: "Stream",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      filterable: true,
    },
    {
      field: "subject",
      headerName: "Subject",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      filterable: true,
    },
    {
      field: "standard",
      headerName: "Education",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      filterable: true,
    },
  ];

  if (canEdit || canDelete) {
    columns.push({
      field: "Actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <div className="flex h-full items-center justify-center gap-3">
          {canEdit && (
            <button
              onClick={() => handleEdit(params.row._id)}
              className="text-fontColor hover:text-primary-2"
            >
              <EditImg />
            </button>
          )}
          {canDelete && (
            <button
              onClick={() => openDeleteModal(params.row._id)}
              className="text-fontColor hover:text-red-500"
            >
              <DeleteImg />
            </button>
          )}
        </div>
      ),
    });
  }

  const {
    selectedSubjectId,
    setSelectedSubjectId,
    subjectData,
    loading,
    searchQuery,
    setSearchQuery,
    handleEdit,
    handleDelete,
    handleStatusUp,
    handleDateFilter,
    handleAdd,
    rowCount,
    paginationModel,
    setPaginationModel,
    setFilterModel,
    setSortingModel,
    // New time sort items
    handleSortByTime,
    timeSortOrder,
  } = useSubject(columns);

  const [isModalOpen, setIsModalOpen] = useState(false); // Modal open state
  const [subjectToDelete, setSubjectToDelete] = useState<string | null>(null);

  const openDeleteModal = (id: string) => {
    setSubjectToDelete(id);
    setIsModalOpen(true);
  };

  const confirmDelete = () => {
    if (subjectToDelete) {
      handleDelete(subjectToDelete);
      setIsModalOpen(false);
    }
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setSubjectToDelete(null);
  };

  return (
    <div className="mx-auto p-4">
      {loading && <Loader />}
      {selectedSubjectId && canEdit ? (
        <EditSubjectIndex subjectId={selectedSubjectId} setSelectedSubjectId={setSelectedSubjectId} />
      ) : (
        <div className=" space-y-4 mt-4 bg-white p-4 rounded-b-lg  shadow-md">
          <div className="flex justify-between items-center gap-4 mr-1 mb-4">
            <TextField
              fullWidth
              variant="outlined"
              label="Search"
              placeholder="Search By"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              size="small"
              sx={{ maxWidth: '400px' }}
            />
            <div className="flex gap-4">
              <Button
                onClick={handleSortByTime}
                className="py-1.5 px-9 rounded"
                children={getSortByTimeButtonText(timeSortOrder)}
                type="button"
              />
              {canAdd && (
                <Button
                  onClick={handleAdd}
                  className="py-1.5 px-9 rounded"
                  children="Add Subject"
                  type="button"
                />
              )}
            </div>
          </div>
          <CommonDataGrid
            id="subject"
            rows={subjectData}
            columns={columns}
            loading={!subjectData}
            showConfirmation={false}

            setFilterModel={setFilterModel}
            setSortingModel={setSortingModel}

            //Pagination
            paginationMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}

            confirmationMessage={""}
            onCancelDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            onConfirmDelete={function (): void {
              throw new Error("Function not implemented.");
            }}
            toolbarProps={{ toolbar: { showQuickFilter: true } }}
          />
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message={getDeleteConfirmationMessage("subject")}
      />
      <Toaster />
    </div>
  );
};

export default Subject;
